import React, { useContext } from "react";
import { TableHead, TableRow, TableCell, Checkbox } from "@mui/material";
import tableIcons from "../../tableIcons";
import ListadoContext from "../../../context/ListadoContext";

function TableHeader({
  cabeceras,
  listadoSeleccion,
  checkAllCheckboxes,
  globalChecked,
  globalIndeterminateChecked,
  handleRequestSort,
}) {
  const columnas = cabeceras
  const { opciones, useDataStore } = useContext(ListadoContext);
  const showSelectAllCheckbox = opciones.showSelectAllCheckbox === "s";

  const order = useDataStore((state) => state.order);
  const orderBy = useDataStore((state) => state.orderBy);

  return (
    <TableHead>
      <TableRow>
        {listadoSeleccion ? (
          <TableCell sx={{ width: "5%" }} width="20px">
            {showSelectAllCheckbox ? (
              <Checkbox
                onClick={() => checkAllCheckboxes()}
                checked={!!globalChecked}
                indeterminate={!!globalIndeterminateChecked}
              />
            ) : (
              <></>
            )}
          </TableCell>
        ) : (
          <></>
        )}
        {columnas.map((c) => {
          if (c.mostrar_como_fila === "s")
            return <React.Fragment key={c.id_a} />;
          return (
            <TableCell key={c.id_a} style={{ textAlign: "left" }}>
              <p
                style={{ cursor: "pointer", padding: 0, margin: 0, fontWeight: "bold" }}
                onClick={(e) =>
                  handleRequestSort(e, c.campo_alias || c.id_a, c.id_a)
                }
              >
                {c.nombre}
                {orderBy === c.id_a || orderBy === c.campo_alias ? (
                  order === "asc" ? (
                    <tableIcons.SortUp fontSize="small" />
                  ) : (
                    <tableIcons.SortDown fontSize="small" />
                  )
                ) : (
                  <></>
                )}
              </p>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

export default TableHeader;
